<jupiter-panel-container [ui]="{ noPadding: true }">
  <jupiter-panel-header
    header
    [panelDef]="panelDef"
    [editMode]="editMode | async"
    (startEditLayout)="onStartEditLayout()"
    (cancelEditLayout)="onCancelEditLayout()"
    (saveLayout)="onSaveLayout()"
  >
    <ng-container customActions> </ng-container>
    <ng-container editModeCustomActions> </ng-container>
  </jupiter-panel-header>
  <ng-container body>
    <ts-table
      [relatedToRedirectConfig]="{}"
      [data]="data$ | async"
      [columnDefs]="columnDefs"
      [hasActionsColumn]="true"
      [hasCheckboxColumn]="false"
      [rowData]="items$ | async"
      rowSelection="multiple"
      [actions]="[]"
      [hasOpenDetailsColumn]="true"
    ></ts-table>
  </ng-container>
</jupiter-panel-container>
